import { Extension } from '@tiptap/core';
// import '../../../../javascript/src/custom-modules/macros/jquery-context-menu/jquery-context-menu';
import { setupContextMenuForRichTextEditor } from '../../../../javascript/src/custom-modules/macros/macro-context-menu/macro-context-menu';

export const ContextMenuMacroExtension = Extension.create({
  name: 'contextMenuMacroExtension',
  onCreate({ editor }) {
    setupContextMenuForRichTextEditor(editor);
  }
});